import _ from 'lodash';

export function getPercentStr(prc) {
    const percValue = prc * 100;
    const roundedValue = Number(percValue.toFixed(1));

    if (Number.isInteger(roundedValue)) {
        return Math.round(percValue);
    }

    return roundedValue;
}

export function hideTooltip(tooltip) {
    if (!Boolean(tooltip)) {
        return;
    }

    tooltip.css({ opacity: '0', visibility: 'hidden' });
}

export function getTooltipId(round, hole, prc) {
    return `${round}_${hole}_${prc}`;
}

export function parseTooltipId(id) {
    if (!id) {
        return {};
    }

    const [round, hole, prob] = id.split('_');

    return {
        probability: Number(prob),
        round,
        hole,
    };
}

export function getTooltipObject(rounds) {
    return _.reduce(
        rounds,
        (memo, round) => {
            const points = round.playerPreEstimatedPoint
                ? [round.playerPreEstimatedPoint, ...round.playerPoints]
                : round.playerPoints;
            const playerTooltips = getTooltipRoundObject(
                round.roundNumber,
                points,
            );

            return Object.assign({}, memo, playerTooltips);
        },
        {},
    );
}

function getTooltipRoundObject(roundNumber, points, object = {}) {
    if (!points || points.length === 0) {
        return object;
    }

    const hasPre = Object.values(points).some(
        (point) => point.holeNumber === 0,
    );

    return _.reduce(
        points,
        (memo, point, index) => {
            const key = getTooltipId(
                roundNumber,
                hasPre ? index : index + 1,
                point.value,
            );
            return Object.assign({}, memo, {
                [key]: memo[key] ? [...memo[key], point.hover] : [point.hover],
            });
        },
        object,
    );
}
